import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import { useForm } from 'react-hook-form';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faMinus, faPlus, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

import Modal from 'react-modal';


const MembrePage = (props) => {
    const token = localStorage.getItem("JWT");

    const [allThings, setAllThings] = useState([]);
    const [modalThings, setAllModalThings] = useState([]);
    const [modalState, setAllModalState] = useState(0);
    const [modalUserID, setAllModalUserID] = useState("");
    const [modalButtonContent, setModalButtonContent] = useState("");


    const [memberRsiProfile, setMemberRsiProfile] = useState("");           // Gestion des etats des infos joueur
    const [memberRangs, setMemberRangs] = useState("");
    const [memberRangsLogo, setMemberRangsLogo] = useState("");
    const [memberEncadrement, setMemberEncadrement] = useState([]);
    const [memberDivisions, setMemberDivisions] = useState([]);
    const [memberPP, setMemberPP] = useState();
    const [memberWarbond, setMemberWarbond] = useState();
    const [memberUEC, setMemberUEC] = useState();

    const [load, setLoad] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);         //gestion de la modal pour les encadrement/division
    const [modalMonnaieIsOpen, setModalMonnaieIsOpen] = useState(false);         //gestion de la modal pour les monnaies


    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm(    // declaration du formulaire et des fonctions nécessaire
        {
            defaultValues: {
                //membres
                pseudoFCU: "",
                memberRsiLien: "",
                memberRsiHandle: "",
                memberRsiId: "",

                //monnaies
                newPP: 0,
                newWarbond: 0,
                newUEC: 0,
            }
        }
    );

    //-----------------------------------------------------Gestion de la modal---------------------------------------------------------//

    function openModal(e) {         // ouverture de la modale 
        let focusThingID = e.target.id

        switch (focusThingID) {
            case "encadrement":
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/allEncadrements`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setAllModalThings(res.data);
                        setIsOpen(true);
                        setAllModalState(1)
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            case "division":
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/allDivisions`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setAllModalThings(res.data);
                        setIsOpen(true);
                        setAllModalState(2)
                    })
                    .catch((err) => {
                        console.log(err);
                    })

                break;

            default:
                break;
        }
    }

    function openModalMonnaie(e) {         // ouverture de la modale 
        setModalMonnaieIsOpen(true)

        switch (e.target.id) {

            case "plus":
                setModalButtonContent("Ajouter")
                break;

            case "minus":
                setModalButtonContent("Retirer")

                break;

            default:
                break;
        }
    }

    function closeModal() {         // fermeture de la modal
        setIsOpen(false);
        setModalMonnaieIsOpen(false)
    }

    const customStyles = {      // gestion du style de la modal
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: "30%",
            height: "50%",
            backgroundColor: "#1a1a1a",
            padding: "15px",
            border: "none",
            outline: "15px solid rgba(18, 18, 18, 0.35)",
            color: "#aaaaaa",
            borderRadius: "0",
        },
    };

    const customStylesMonnaies = {      // gestion du style de la modal
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: "30%",
            height: "50%",
            backgroundColor: "#1a1a1a",
            padding: "15px",
            border: "none",
            outline: "15px solid rgba(18, 18, 18, 0.35)",
            color: "#aaaaaa",
            borderRadius: "0",
        },
    };

    //---------------------------------------------------Delete encadrement / division -----------------------------------------//

    const deleteEncadrement = (e) => {
        const thingId = e.target.id;
        confirmAlert({
            title: "Rétrograder ce membre ?",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        axios({
                            method: "delete",
                            url: `${process.env.REACT_APP_API_URL}api/deleteEncadrementToUser`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },
                            data: {
                                userId: modalUserID,
                                encadrementId: thingId
                            }
                        })
                            .then((res) => {
                                toast.success("le joueur a ete rétrogradé!");
                                axios({
                                    method: "get",
                                    url: `${process.env.REACT_APP_API_URL}api/auth/user/${modalUserID}`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    }
                                })
                                    .then((res) => {
                                        setMemberEncadrement(res.data.encadrements)
                                        setMemberDivisions(res.data.divisions)
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })


                            })
                            .catch((err) => {
                                toast.error("Erreur lors de la rétrogradation!");
                                console.log(err);
                            })
                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });


    }

    const deleteDivision = (e) => {
        const thingId = e.target.id;

        confirmAlert({
            title: "Rétrograder ce membre ?",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        axios({
                            method: "delete",
                            url: `${process.env.REACT_APP_API_URL}api/deleteDivisionToUser`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },
                            data: {
                                userId: modalUserID,
                                divisionId: thingId
                            }
                        })
                            .then((res) => {
                                toast.success("le joueur a ete rétrogradé!");
                                axios({
                                    method: "get",
                                    url: `${process.env.REACT_APP_API_URL}api/auth/user/${modalUserID}`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    }
                                })
                                    .then((res) => {
                                        setMemberEncadrement(res.data.encadrements)
                                        setMemberDivisions(res.data.divisions)
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })


                            })
                            .catch((err) => {
                                toast.error("Erreur lors de la rétrogradation!");
                                console.log(err);
                            })

                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });


    }

    //---------------------------------------------------Barre de recherche-----------------------------------------//

    const searchBar = (e) => {
        let search = e.target.value;
        search = search.toUpperCase();
        let x = document.getElementsByClassName('liste');

        for (const list of x) {
            let listTitle = list.firstChild
            let listId = list.id
            listTitle = listTitle.innerHTML

            if (!listTitle.toUpperCase().includes(search) && listId !== search) {
                list.style.display = "none";
            }
            else {
                list.style.display = "flex";
            }
        }
    }

    //---------------------------------------------------Get all member-----------------------------------------//

    const getMembers = (e) => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/auth/user`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                setAllThings(res.data);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    //---------------------------------------------------get One member-----------------------------------------//

    const displayOneMember = (e) => {
        let focusId = e.target.id
        localStorage.setItem("focusId", focusId)
        setLoad(true)

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/auth/userDiscord/${focusId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                setValue('pseudoFCU', res.data.pseudoFCU);
                setValue('memberRsiLien', res.data.RSIProfile);
                setValue('memberRsiHandle', res.data.RSIHandle);
                setValue('memberRsiId', res.data.RSIID);

                setMemberRsiProfile(res.data.RSIProfile)
                setMemberRangs(res.data.rang.nom)
                setMemberRangsLogo(res.data.rang.logo)
                setMemberEncadrement(res.data.encadrements)
                setMemberDivisions(res.data.divisions)
                setAllModalUserID(res.data.id)
                setMemberPP(res.data.PP)
                setMemberWarbond(res.data.warbonds)
                setMemberUEC(res.data.UEC)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    //---------------------------------------------------modifier un joueur-----------------------------------------//

    const modify = data => {
        let thingId = localStorage.getItem("focusId")

        let pseudoFCU = data.pseudoFCU
        let PP = data.PP
        let UEC = data.UEC
        let warbonds = data.warbonds
        let RSIHandle = data.memberRsiHandle
        let RSIID = data.memberRsiId
        let RSIProfile = data.memberRsiLien

        // console.log(hashtag);
        // console.log(nom);
        // console.log(prix);
        // console.log(description);
        // console.log(rarete);
        // console.log(disponible);
        // console.log(aquisition);

        axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/auth/modifyMember/${thingId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                pseudoFCU,
                PP,
                UEC,
                warbonds,
                RSIHandle,
                RSIID,
                RSIProfile,
            }

        })
            .then((res) => {
                toast.success("joueur modifié!");
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/auth/user`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    },


                })
                    .then((res) => {
                        setAllThings(res.data);
                    })
                    .catch((err) => {
                        console.log(err);
                    })

            })
            .catch((err) => {
                console.log(err);
                toast.error("Erreur lors de la modification du joueur!");
            })
    }

    const addEncadrementDivision = (e) => {
        const thingId = e.target.id;

        confirmAlert({
            title: "Promouvoir ce membre?",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        switch (modalState) {
                            case 1:
                                axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}api/addEncadrementToUser`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    },
                                    data: {
                                        userId: modalUserID,
                                        encadrementId: thingId
                                    }
                                })
                                    .then((res) => {
                                        toast.success("Succès de la promotion!");
                                        setIsOpen(false);
                                        axios({
                                            method: "get",
                                            url: `${process.env.REACT_APP_API_URL}api/auth/user/${modalUserID}`,
                                            headers: {
                                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                            }
                                        })
                                            .then((res) => {
                                                setMemberEncadrement(res.data.encadrements)
                                                setMemberDivisions(res.data.divisions)
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                            })


                                    })
                                    .catch((err) => {
                                        toast.error("Erreur lors de la promotion du joueur!");
                                        console.log(err);
                                    })
                                break;

                            case 2:
                                axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}api/addDivisionsToUser`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    },
                                    data: {
                                        userId: modalUserID,
                                        divisionId: thingId
                                    }
                                })
                                    .then((res) => {
                                        toast.success("Succès de la promotion!");
                                        setIsOpen(false);
                                        axios({
                                            method: "get",
                                            url: `${process.env.REACT_APP_API_URL}api/auth/user/${modalUserID}`,
                                            headers: {
                                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                            }
                                        })
                                            .then((res) => {
                                                setMemberEncadrement(res.data.encadrements)
                                                setMemberDivisions(res.data.divisions)
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                            })


                                    })
                                    .catch((err) => {
                                        toast.error("Erreur lors de la promotion du joueur!");
                                        console.log(err);
                                    })

                                break;

                            default:
                                break;
                        }

                    },

                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });




    }

    const addMonnaie = data => {
        let thingId = localStorage.getItem("focusId")

        let PP = parseInt(data.newPP, 10);
        let warbonds = parseInt(data.newWarbond, 10);
        let UEC = parseInt(data.newUEC, 10);

        axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/auth/addMonnaie/${thingId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                PP,
                warbonds,
                UEC
            }

        })
            .then((res) => {
                reset({
                    newPP: 0,
                    newWarbond: 0,
                    newUEC: 0
                });
                setModalMonnaieIsOpen(false);
                toast.success("Porte-monnaie modifié!");

                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/auth/userDiscord/${thingId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setMemberPP(res.data.PP)
                        setMemberWarbond(res.data.warbonds)
                        setMemberUEC(res.data.UEC)
                    })
                    .catch((err) => {
                        console.log(err);
                    })

            })
            .catch((err) => {
                toast.error("Erreur lors de la modification du joueur!");
            })

    }

    const deleteMonnaie = data => {
        let thingId = localStorage.getItem("focusId")

        let PP = parseInt(data.newPP, 10);
        let warbonds = parseInt(data.newWarbond, 10);
        let UEC = parseInt(data.newUEC, 10);

        axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/auth/deleteMonnaie/${thingId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                PP,
                warbonds,
                UEC
            }

        })
            .then((res) => {
                reset({
                    newPP: 0,
                    newWarbond: 0,
                    newUEC: 0
                });
                setModalMonnaieIsOpen(false);
                toast.success("Porte-monnaie modifié!");

                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/auth/userDiscord/${thingId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setMemberPP(res.data.PP)
                        setMemberWarbond(res.data.warbonds)
                        setMemberUEC(res.data.UEC)
                    })
                    .catch((err) => {
                        console.log(err);
                    })

            })
            .catch((err) => {
                toast.error("Erreur lors de la modification du joueur!");
            })

    }

    //---------------------------------------------------Supprimer un joueur-----------------------------------------//

    function deleteThings(e) {      //supprimer un objet

        let thingId = localStorage.getItem("focusId")

        confirmAlert({
            title: "Supprimer ce membre de la corpo?",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        axios({
                            method: "delete",
                            url: `${process.env.REACT_APP_API_URL}api/auth/deleteMember/${thingId}`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            }

                        })
                            .then((res) => {
                                toast.success("Joueur supprimé!");
                                axios({
                                    method: "get",
                                    url: `${process.env.REACT_APP_API_URL}api/auth/user`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    }

                                })
                                    .then((res) => {
                                        setAllThings(res.data);
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })
                            })
                            .catch((err) => {
                                console.log(err);
                                toast.error("Erreur de suppression!");
                            })
                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });


    }

    useEffect(() => {
        getMembers()
    }, []);


    return (

        <div className='manageMember'>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="modal modif Member"
                ariaHideApp={false}
            >
                <div className='modalModifMember'>
                    <h2>Promouvoir un membre FCU</h2>
                    <div className='ModalArrayCont'>
                        {modalThings.map((encadrant) => (
                            <div key={encadrant.id} className="arrayModifMember">
                                <p>- {encadrant.nom}</p>
                                <FontAwesomeIcon id={encadrant.id} onClick={addEncadrementDivision} icon={faPlus} />
                            </div>
                        ))}
                    </div>

                </div>

            </Modal>

            <Modal
                isOpen={modalMonnaieIsOpen}
                onRequestClose={closeModal}
                style={customStylesMonnaies}
                contentLabel="modal update monnaies"
                ariaHideApp={false}
            >
                <div className='modalUpdateMonnaies'>
                    <h2>Modifier le porte-monnaie d'un membre FCU:</h2>
                    <form onSubmit={modalButtonContent === "Retirer" ? handleSubmit(deleteMonnaie) : handleSubmit(addMonnaie)}>
                        <span>
                            <img src="images/PP.png" alt="logo Warbond" />
                            <input type="number"{...register("newPP")} required />
                        </span>

                        <span>
                            <img src="images/warbond.png" alt="logo Warbond" />
                            <input type="number"{...register("newWarbond")} required />
                        </span>

                        <span>
                            <img src="images/uec.png" alt="logo uec" />
                            <input type="number"{...register("newUEC")} required />
                        </span>

                        <input className={`submitMonnaieForm ${modalButtonContent === "Retirer" ? "warningColor" : ""}`} type="submit" value={modalButtonContent} />

                    </form>
                </div>

            </Modal>

            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
            />

            <Link className='exitButton' to="/profil"><FontAwesomeIcon icon={faArrowLeft} /></Link>

            <div className='manageMember__backgroundList'>
                <div className='manageMember__backgroundList__list'>
                    <div className='searchBar'>
                        <label htmlFor="searchBar">Rechercher (par ID ou par pseudo):</label>
                        <input className='ongletModif__container__list__searchBarContainer__searchBar' type="text" id="searchBar" name="searchBar" onChange={searchBar} />
                    </div >
                    <div className='adminMemberList'>
                        {allThings.map(things => (
                            <div className='liste' key={things.id} id={things.discordID} onClick={displayOneMember} >
                                <p>{things.pseudoFCU}</p>
                            </div>
                        ))}
                    </div>
                    <div className='deleteUserCont'>
                        <button onClick={deleteThings} >Supprimer</button>
                        <p><FontAwesomeIcon icon={faTriangleExclamation} />  La suppression d'un membre de la corpo entraîne la perte définitive de ses données.</p>
                    </div>

                </div>
            </div>



            <div className='manageMember__backgroundInfo'>
                <div className='manageMember__backgroundInfo__info'>

                    {!load ?
                        <p>Modifiez les informations d'un membre de la corpo, ajoutez des PP/UEC a son compte ou supprimez quelqu'un de la base de données.</p>
                        :

                        <form className='displayMember' onSubmit={handleSubmit(modify)}>

                            <div className='displayMember__header'>
                                <span className='modifRankFCU'>
                                    <img src={memberRangsLogo} />
                                    <p>{memberRangs}</p>
                                </span>
                                <span className='modifPseudoFCU' >
                                    <input type="text" id="memberPseudoFCU" name="memberPseudoFCU"  {...register("pseudoFCU")} required />
                                </span>
                                <span className='rsiLink'>
                                    <a href={memberRsiProfile} target="_blank"> <img src='../images/RSILogo.png' /> </a>
                                </span>
                            </div>

                            <div className='displayMember__section'>
                                <div className='displayMember__section__container'>

                                    <div className='displayMember__section__container__title'>
                                        <FontAwesomeIcon className='displayMember__section__container__title__svgMinus' onClick={openModalMonnaie} id='minus' icon={faMinus} />
                                        <h2>Porte-monnaie</h2>
                                        <FontAwesomeIcon className='displayMember__section__container__title__svgPlus' onClick={openModalMonnaie} id='plus' icon={faPlus} />
                                    </div>

                                    <div className='displayMember__section__container__content'>

                                        <span>
                                            <img src="images/PP.png" alt="logo Warbond" />
                                            <p>{memberPP && memberPP.toLocaleString("fr-FR")}</p>
                                        </span>

                                        <span>
                                            <img src="images/warbond.png" alt="logo Warbond" />
                                            <p>{memberWarbond && memberWarbond.toLocaleString("fr-FR")}</p>
                                        </span>

                                        <span>
                                            <img src="images/uec.png" alt="logo uec" />
                                            <p>{memberUEC && memberUEC.toLocaleString("fr-FR")}</p>
                                        </span>

                                    </div>
                                </div>

                                <div className='displayMember__section__container middleCont'>

                                    <h2>Informations RSI:</h2>
                                    <div className='displayMember__section__container__content'>
                                        <span>
                                            <label htmlFor="memberRsiId">RSI ID:</label>
                                            <input type="text" id="memberRsiId" name="memberRsiId"  {...register("memberRsiId")} required />
                                        </span>

                                        <span>
                                            <label htmlFor="memberRsiLien">RSI URL:</label>
                                            <input type="text" id="memberRsiLien" name="memberRsiLien"  {...register("memberRsiLien")} required />
                                        </span>

                                        <span>
                                            <label htmlFor="memberRsiHandle">RSI Handle:</label>
                                            <input type="text" id="memberRsiHandle" name="memberRsiHandle"  {...register("memberRsiHandle")} required />
                                        </span>
                                    </div>
                                </div>

                                <div className='displayMember__section__lastContainer'>
                                    <div className='displayMember__section__lastContainer__encadrement'>
                                        <div className='displayMember__section__lastContainer__encadrement__title'>
                                            <h2>Statuts d'encadrements</h2>
                                            <FontAwesomeIcon onClick={openModal} id='encadrement' icon={faPlus} />
                                        </div>


                                        {memberEncadrement.length > 0 ?
                                            <div className='MemberArrayCont'>
                                                {memberEncadrement.map((encadrant) => (
                                                    <div key={encadrant.id} className="arrayModifMember">
                                                        <p>- {encadrant.nom}</p>
                                                        <FontAwesomeIcon onClick={deleteEncadrement} id={encadrant.id} icon={faMinus} />
                                                    </div>
                                                ))}
                                            </div>
                                            :
                                            <p>- Aucun</p>
                                        }
                                    </div>
                                    <div className='displayMember__section__lastContainer__encadrement'>

                                        <div className='displayMember__section__lastContainer__encadrement__title'>
                                            <h2>Divisions actives</h2>
                                            <FontAwesomeIcon onClick={openModal} id='division' icon={faPlus} />
                                        </div>

                                        {memberDivisions.length > 0 ?
                                            <div className='MemberArrayCont'>
                                                {memberDivisions.map((division) => (
                                                    <div key={division.id} className="arrayModifMember">
                                                        <p>- {division.nom}</p>
                                                        <FontAwesomeIcon onClick={deleteDivision} id={division.id} icon={faMinus} />
                                                    </div>
                                                ))}
                                            </div>
                                            :
                                            <p>- Aucun</p>
                                        }

                                    </div>

                                </div>


                            </div>

                            <input className='memberButtonModif' type="submit" value="Modifier" />
                        </form>


                    }
                </div>
            </div>

        </div>
    );
};

export default MembrePage;